import React from 'react'
import type { Playlist } from 'types/playlist'
import PlaylistInfo from 'components/common/playlist-info'
import PaneItem from 'components/ui/pane-item'
type Props = {
  playlist: Playlist
}

/**
 * Playlist drag preview component that displays playlist information during drag
 * Shows playlist details in a pane item format for drag and drop operations
 * @param playlist - Playlist object to display in the drag preview
 */
const PlaylistDragPreview = ({ playlist }: Props) => (
  <PaneItem
    appearance="default"
    className="pane-item--inset"
    content={<PlaylistInfo playlist={playlist} />}
  />
)

export default React.memo<Props>(PlaylistDragPreview)
